import { AddEvent, ClickEvent, ViewEvent } from '~/passporter-services/shared/metrics'
import { BaseMetric } from './baseMetric'
import mixpanel from 'mixpanel-browser'
import { PRODUCT_CATEGORY } from '~/models/Product'

export class TripProductMetric extends BaseMetric {
	public static viewStore(
		tripId: string,
		destinationName: string,
		userRole: string,
		category: PRODUCT_CATEGORY,
		routeName: string
	): void {
		const element = category === PRODUCT_CATEGORY.ACTIVITY ? 'ts_activities' : 'ts_ideas'
		new ViewEvent(element, routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}

	public static addFavorite(
		tripId: string,
		destinationName: string,
		productId: string,
		userRole: string,
		category: PRODUCT_CATEGORY,
		routeName: string
	): void {
		const element = category === PRODUCT_CATEGORY.ACTIVITY ? 'ts_activity' : 'ts_idea'
		new AddEvent(element, routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.addParam(`${element}_id`, productId)
			.send(this.gtag, mixpanel)
	}

	public static viewDetail(
		tripId: string,
		destinationName: string,
		productId: string,
		userRole: string,
		category: PRODUCT_CATEGORY,
		routeName?: string
	): void {
		const element = category === PRODUCT_CATEGORY.ACTIVITY ? 'ts_activity' : 'ts_idea'
		new ViewEvent(element, routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('idea_id', productId)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}

	public static clickDetail(
		tripId: string,
		destinationName: string,
		productId: string,
		userRole: string,
		category: PRODUCT_CATEGORY,
		routeName?: string
	): void {
		const element = category === PRODUCT_CATEGORY.ACTIVITY ? 'ts_activity' : 'ts_idea'
		new ClickEvent(element, routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('idea_id', productId)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}

	public static viewIndispensables(
		tripId: string,
		destinationName: string,
		userRole: string,
		routeName: string
	): void {
		new ViewEvent('ts_affiliates', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.send(this.gtag, mixpanel)
	}

	public static clickIndispensable(
		tripId: string,
		destinationName: string,
		userRole: string,
		affiliateId: string,
		routeName?: string
	): void {
		new ClickEvent('ts_affiliate', routeName)
			.addParam('trip_id', tripId)
			.addParam('trip_destination', destinationName)
			.addParam('user_role', userRole)
			.addParam('affiliate_id', affiliateId)
			.send(this.gtag, mixpanel)
	}
}
